import ApplicationComponent from "legacy/ApplicationComponent"
import PropTypes from "prop-types"
import React from "react"

// HIGHLY RECOMMENDED NOT TO USE
// PLEASE SEE ONE-PAGER AND COMMENTS
// FOR DISCUSSION AND FOR THE ONLY PROPER USE-CASE
// OF THIS COMPONENT:
// https://wanderlustgroup.atlassian.net/wiki/spaces/TEC/pages/3271655669/Modernity+in+Antiquity+-+New+World+React+components+in+the+legacy+system

class DeprecatedOldReactAdapterComponentContainer extends ApplicationComponent {
  componentDidMount() {
    // dispatching custom event once container loads for DangerousDeprecatedOldReactAdapterComponent to listen to
    const event = new CustomEvent(`${this.props.id}-element-loaded`)
    document.dispatchEvent(event)
  }

  componentWillUnmount() {
    // dispatching hide event if container is being unmounted
    const event = new CustomEvent(`${this.props.id}-element-removed`)
    document.dispatchEvent(event)
  }

  render() {
    return <div id={this.props.id}>{this.props.children}</div>
  }
}

DeprecatedOldReactAdapterComponentContainer.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export default DeprecatedOldReactAdapterComponentContainer
